/**
 * Session Manager
 * Handles session timeout rules: 8 hours inactivity
 */
import { logger } from "@/infrastructure/services/LoggerService";
const INACTIVITY_TIMEOUT = 8 * 60 * 60 * 1000; // 8 hours
const LAST_ACTIVITY_KEY = "session-last-activity";
export function initializeSession() {
    const now = Date.now();
    sessionStorage.setItem(LAST_ACTIVITY_KEY, now.toString());
    logger.debug("Session initialized");
}
export function updateActivity() {
    const now = Date.now();
    sessionStorage.setItem(LAST_ACTIVITY_KEY, now.toString());
}
export function checkSessionValidity() {
    const lastActivityStr = sessionStorage.getItem(LAST_ACTIVITY_KEY);
    if (!lastActivityStr) {
        return {
            isValid: false,
            reason: "no_session",
        };
    }
    const now = Date.now();
    const lastActivity = parseInt(lastActivityStr, 10);
    if (isNaN(lastActivity)) {
        return {
            isValid: false,
            reason: "no_session",
        };
    }
    const timeSinceActivity = now - lastActivity;
    if (timeSinceActivity > INACTIVITY_TIMEOUT) {
        return {
            isValid: false,
            reason: "inactivity",
            lastActivity,
        };
    }
    const inactivityRemaining = INACTIVITY_TIMEOUT - timeSinceActivity;
    return {
        isValid: true,
        lastActivity,
        inactivityRemaining,
    };
}
export function clearSession() {
    sessionStorage.removeItem(LAST_ACTIVITY_KEY);
    logger.debug("Session data cleared");
}
